import PropTypes from 'prop-types';
import React from 'react';
import Spinner from '../../../_generic/spinner/Spinner';
import BookingCalendarProduct from './BookingCalendarProduct';

const BookingCalendarProducts = ({
  currency,
  isBCOR,
  isCYF,
  priceDiff,
  products,
  selection,
  quantity,
  onSelect,
  onQuantityChange,
}) => {
  if (products.length === 0) {
    return (
      <>
        <div className="booking-calendar--loading">
          <Spinner />
        </div>
        <style jsx>{`
          .booking-calendar--loading {
            position: relative;
            min-height: 300px;
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <div className="booking-calendar__products">
        {products.map((product, index) => (
          <BookingCalendarProduct
            currency={currency}
            isBCOR={isBCOR}
            isCYF={isCYF}
            key={index}
            onQuantityChange={onQuantityChange}
            onSelect={onSelect}
            priceDiff={priceDiff}
            product={product}
            quantity={quantity}
            selected={
              selection?.dealVoucherProductId === product.dealVoucherProductId
            }
          />
        ))}
      </div>
      <style jsx>{`
        .booking-calendar__products {
          margin-bottom: 20px;
        }
      `}</style>
    </>
  );
};

BookingCalendarProducts.propTypes = {
  currency: PropTypes.string,
  isBCOR: PropTypes.bool,
  isCYF: PropTypes.bool,
  onQuantityChange: PropTypes.func,
  onSelect: PropTypes.func,
  priceDiff: PropTypes.number,
  products: PropTypes.array,
  quantity: PropTypes.number,
  selection: PropTypes.object,
};

BookingCalendarProducts.defaultProps = {
  currency: 'gbp',
  isBCOR: false,
  isCYF: false,
  onQuantityChange: () => false,
  onSelect: () => false,
  priceDiff: 0,
  products: [],
  quantity: 1,
  selection: null,
};

export default BookingCalendarProducts;
